import { render, staticRenderFns } from "./MobileMaridaje.vue?vue&type=template&id=0815c8cc&scoped=true"
import script from "./MobileMaridaje.vue?vue&type=script&lang=js"
export * from "./MobileMaridaje.vue?vue&type=script&lang=js"
import style0 from "./MobileMaridaje.vue?vue&type=style&index=0&id=0815c8cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815c8cc",
  null
  
)

export default component.exports